export const getDateString = () => {
	return (new Date()).toISOString().substring(0, 10);
};
export default {
	getDateString
};